import React, { useEffect, useState } from "react";
import { Toast } from "primereact/toast";

const GlobalToast = () => {
  const [messages, setMessages] = useState([]);

  const showToast = (severity, summary, detail) => {
    setMessages((prevMessages) => [
      ...prevMessages,
      { severity, summary, detail },
    ]);
  };

  const clearToast = () => {
    setMessages([]);
  };
  return (
    <>
      <Toast ref={(el) => (window.toast = el)} />
      {messages.map((message, index) => (
        <Toast
          key={index}
          ref={(el) => (window.toast = el)}
          severity={message.severity}
          summary={message.summary}
          detail={message.detail}
        />
      ))}
    </>
  );
};

export default GlobalToast;
